const locations = document.querySelector('.archive-locations')

const locationLinks = locations.querySelector('.locations')

// Set initial answer height
locationLinks.style.setProperty(
	'--location-height',
	`${locationLinks.scrollHeight}px`
)
// Handle window resize to adjust the answer height dynamically
window.addEventListener('resize', () => {
	locationLinks.style.setProperty('--location-height', `auto`)
	locationLinks.style.setProperty(
		'--location-height',
		`${locationLinks.scrollHeight}px`
	)
})

const button = locations.querySelector('.label')
button.addEventListener('click', () => {
	button.classList.toggle('active')
})
